export class Random {
  public seed: number;

  constructor();
  constructor(seed: number);
  constructor() {
    if (arguments.length === 0) {
      this.seed = new Date().getTime();
      this.NextInt();
    } else {
      this.seed = arguments[0];
    }
  }

  public NextInt(): number {
    let x = this.seed;
    x ^= x << 13;
    x ^= x >> 17;
    x ^= x << 5;
    this.seed = x;
    return x & 0x7fffffff;
  }

  // min以上、max以下の値を返す。つまりmaxも含まれる。
  public NextIntRange(min: number, max: number): number;
  public NextIntRange(range: { min: number; max: number }): number;
  public NextIntRange(): number {
    let min: number, max: number;
    if (arguments.length === 1) {
      min = arguments[0].min;
      max = arguments[0].max;
    } else {
      min = arguments[0];
      max = arguments[1];
    }
    return (this.NextInt() % (max - min + 1)) + min;
  }

  public NextSingle(): number {
    let v = this.NextInt() / 536870911.0;
    return v - Math.floor(v);
  }

  public NextSingleRange(min: number, max: number): number;
  public NextSingleRange(range: { min: number; max: number }): number;
  public NextSingleRange(): number {
    let min: number, max: number;
    if (arguments.length === 1) {
      min = arguments[0].min;
      max = arguments[0].max;
    } else {
      min = arguments[0];
      max = arguments[1];
    }
    return this.NextSingle() * (max - min) + min;
  }

  public NextSign(): number {
    return this.NextInt() % 2 ? -1 : +1;
  }
}
